import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

interface OutOfDateAlertProps {
  hasUnsavedChanges: boolean;
  onRefresh: () => void;
}

export const OutOfDateAlert: FC<OutOfDateAlertProps> = ({
  hasUnsavedChanges,
  onRefresh,
}) => {
  const { t } = useTranslation();
  return (
    <Alert
      severity="info"
      className="mb-8"
      action={
        <Button color="inherit" size="small" onClick={onRefresh}>
          {hasUnsavedChanges
            ? t(
                "components.categoryCollectionProfile.actions.discardAndRefresh"
              )
            : t("utils.actions.reload")}
        </Button>
      }
    >
      {hasUnsavedChanges
        ? t("components.categoryCollectionProfile.warnings.outOfDateWithDraft")
        : t("components.categoryCollectionProfile.warnings.outOfDate")}
    </Alert>
  );
};
